"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Phase = exports.Finalization = exports.ApplyExtrinsic = void 0;

var _util = require("@plugnet/util");

var _EnumType = _interopRequireDefault(require("../codec/EnumType"));

var _Struct = _interopRequireDefault(require("../codec/Struct"));

var _Null = _interopRequireDefault(require("../primitive/Null"));

var _U = _interopRequireDefault(require("../primitive/U32"));

var _Event = _interopRequireDefault(require("./Event"));

// Copyright 2017-2019 @polkadot/types authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * @name ApplyExtrinsic
 * @description
 * The [[Phase]] where the extrinsic is applied
 */
class ApplyExtrinsic extends _U.default {}
/**
 * @name Finalization
 * @description
 * The [[Phase]] where the extrinsic is being Finalized
 */


exports.ApplyExtrinsic = ApplyExtrinsic;

class Finalization extends _Null.default {}
/**
 * @name Phase
 * @description
 * An [[EnumType]] that indicates the specific phase where the [[EventRecord]] was generated
 */


exports.Finalization = Finalization;

class Phase extends _EnumType.default {
  constructor(value, index) {
    super({
      ApplyExtrinsic,
      Finalization
    }, value, index);
  }
  /**
   * @description Returns the item as a [[ApplyExtrinsic]]
   */


  get asApplyExtrinsic() {
    (0, _util.assert)(this.isApplyExtrinsic, "Cannot convert '".concat(this.type, "' via asApplyExtrinsic"));
    return this.value;
  }
  /**
   * @description Returns the item as a [[Finalization]]
   */


  get asFinalization() {
    (0, _util.assert)(this.isFinalization, "Cannot convert '".concat(this.type, "' via asFinalization"));
    return this.value;
  }
  /**
   * @description true when this is a ApplyExtrinsic
   */


  get isApplyExtrinsic() {
    return this.type === 'ApplyExtrinsic';
  }
  /**
   * @description true when this is a ApplyExtrinsic
   */


  get isFinalization() {
    return this.type === 'Finalization';
  }

}
/**
 * @name EventRecord
 * @description
 * A record for an [[Event]] (as specified by [[Metadata]]) with the specific [[Phase]] of
 * application.
 */


exports.Phase = Phase;

class EventRecord extends _Struct.default {
  constructor(value) {
    super({
      phase: Phase,
      event: _Event.default
    }, value);
  }
  /**
   * @description The [[Event]] this record refers to
   */


  get event() {
    return this.get('event');
  }
  /**
   * @description The [[Phase]] where the event was generated
   */


  get phase() {
    return this.get('phase');
  }

}

exports.default = EventRecord;